import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import type { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';

import { useOpenPolicy } from './hooks/useOpenPolicy';

export enum PolicyType {
  PrivacyPolicy,
  TermsOfService,
}

interface PrivacyPolicyTextProps {
  className?: string;
  children: ReactNode;
  type: PolicyType;
}

const UnstyledPrivacyPolicyText: FunctionComponent<PrivacyPolicyTextProps> = ({ className, children, type }) => {
  const openPolicy = useOpenPolicy();

  return (
    <>
      <Box display="inline-block" onClick={() => openPolicy(type)} className={className}>
        <Typography variant="inherit">{children}</Typography>
      </Box>
    </>
  );
};

export const PrivacyPolicyText = styled(UnstyledPrivacyPolicyText)`
  color: #ff3975;
  text-decoration: underline;
  text-decoration-skip-ink: none;
  cursor: pointer;
`;
